<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="endpoint()"
      [chartColumn]="'Name'"
      [hasIndexCol]="!!userId()"
    ></app-api-table>
  }
</app-tab-layout>
